import { useTheme } from "../../theme/useTheme"
import { ContentSection } from "../layout/ContentSection"
import { SectionItemTitle } from "../ui/CustomTypography"
import { Box, Typography } from "@mui/material"

interface Education {
    degree: string
    degreeExtra?: string
    university: string
    country: string
}

export const Education = () => {
    const { layout, breakpoints } = useTheme()
    const educations: Education[] = [
        {
            degree: "M.Sc. Computer Science",
            degreeExtra: "Merit scholarship from Chevron",
            university: "Chulalongkorn University",
            country: "Thailand",
        },
        {
            degree: "B.Sc., Chemical Engineering",
            university: "Chulalongkorn University",
            degreeExtra: "1st Hons, ranked first in class",
            country: "Thailand",
        },
    ]

    return (
        <ContentSection title="Education">
            {educations.map((edu, index) => (
                <Box
                    key={index}
                    sx={{
                        display: "flex",
                        flexDirection: breakpoints.isFullPage ? "row" : "column",
                        justifyContent: "space-between",
                        marginBottom: layout.verticalSpacing * 0.7,
                    }}
                >
                    <Box data-testid="degree-container">
                        <SectionItemTitle>{edu.degree}</SectionItemTitle>
                        {edu.degreeExtra && (
                            <Typography variant="body1" sx={{ display: "inline" }}>
                                {" "}
                                ({edu.degreeExtra})
                            </Typography>
                        )}
                    </Box>
                    <Box
                        sx={{
                            textAlign: breakpoints.isFullPage ? "right" : "left",
                            marginLeft: breakpoints.isFullPage ? "auto" : 0,
                            display: "flex",
                            alignItems: "end",
                            justifyContent: breakpoints.isFullPage ? "flex-end" : "flex-start",
                        }}
                        data-testid="university-container"
                    >
                        <Typography variant="body1" sx={{ marginBottom: 0 }}>
                            {edu.university}, {edu.country}
                        </Typography>
                    </Box>
                </Box>
            ))}
        </ContentSection>
    )
}
